/**
 * Age calculation utilities for Ignite age verification.
 *
 * Self-declared DOB is intentional — no third-party verification.
 */

/**
 * Calculate completed years of age from a DOB string (YYYY-MM-DD or ISO).
 * @param {string} dobString
 * @returns {number|null} integer age in completed years, or null if invalid
 */
export function getAgeFromDob(dobString) {
  if (!dobString) return null;
  const today = new Date();
  const dob   = new Date(dobString);
  if (isNaN(dob.getTime())) return null;
  let age = today.getFullYear() - dob.getFullYear();
  const m = today.getMonth() - dob.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) age--;
  return age;
}

/**
 * Derive an ageGroup string from a completed age.
 * @param {number|null} age
 * @returns {'blocked'|'minor'|'adult'|null}
 */
export function getAgeGroup(age) {
  if (age === null || age === undefined) return null;
  if (age < 13)  return 'blocked';
  if (age < 18)  return 'minor';
  return 'adult';
}
